module.exports = __webpack_public_path__ + "img/favourite-game.53e5d80e.svg";